import { Chip, Grid, Stack, Typography } from "@mui/material";
import englishTranslations from "./translations/en";
import { AccountSelector } from "./features/AccountSelector";
import { useContext } from "react";
import { appContext } from "./context/AppContext";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AccountPageTiles } from "./layouts/AccountPageTiles";
import { AccountTeam } from "./features/AccountTeam";
import { AccountSecurity } from "./features/AccountSecurity";
import { AccountDashboard } from "./features/AccountDashboard";
import { useCheckAccess } from "./hooks/useCheckAccess";

export function AppComponent(props) {
  const context = useContext(appContext);
  const canUseDashboard = useCheckAccess("dashboard", context.user);
  
  return (
    <Grid container spacing={4} pl={3} pr={3}>
      <Grid item xs={12}>
        <Stack spacing={2} direction={"row"} alignItems={"center"}>
          <Typography variant={"h1"} color={"primary.main"}>
            {englishTranslations.title}
          </Typography>
          <Chip
            color={"secondary"}
            size={"medium"}
            variant={"outlined"}
            label={"Under Development"}
          />
        </Stack>

        <Typography variant={"body1"} marginTop={"8px"}>
          {englishTranslations.description}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <AccountSelector />
      </Grid>
      <BrowserRouter>
        <Routes>
          <Route path="/account" element={<AccountPageTiles />}></Route>
          <Route
            path="/account/team-members"
            element={<AccountTeam {...props} />}
          ></Route>
          <Route
            path="/account/hardware-security"
            element={<AccountSecurity {...props} />}
          ></Route>
          {canUseDashboard && (
            <Route
              path="/account/dashboards"
              element={<AccountDashboard {...props} />}
            ></Route>
          )}
        </Routes>
      </BrowserRouter>
    </Grid>
  );
}
